// eslint-disable-next-line max-len
import {ZustandigkeitsvereinbarungAngabenComponent} from '../../fragebogen/kapg-aus/component/zustandigkeitsvereinbarung-angaben/zustandigkeitsvereinbarung-angaben.component';
import {AppNameEnum, ZustandigkeitsvereinbarungAngaben} from '@nachdigal';
import {ComponentHelper, TaskDataService} from '@utils-lib';
import {ActivatedRoute} from '@angular/router';
import {
    Component,
    ComponentFactoryResolver,
    Directive,
    ElementRef,
    EventEmitter,
    OnInit,
    Output,
    Renderer2,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';

@Directive({
    selector: '[commonUiOptionalWizardStep]'
})
export class OptionalWizardStepDirective implements OnInit {

    constructor(
        private readonly viewContainer: ViewContainerRef,
        private readonly templateRef: TemplateRef<unknown>,
        private readonly componentFactoryResolver: ComponentFactoryResolver,
        private readonly taskDataService: TaskDataService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly renderer: Renderer2,
        private readonly elRef: ElementRef) {
    }

    ngOnInit(): void {
        const factory = this.componentFactoryResolver.resolveComponentFactory(InfoOptionalStepComponent);
        this.viewContainer.clear();
        if (this.shouldShowHeaderSwitch()) {
            const optionalStepComponent = this.viewContainer.createComponent(factory);
            optionalStepComponent.instance.overrideSwitched.subscribe(override => this.handleOverrideSwitched(override));
            if (!this.shouldShowContent()) {
                const parent = this.renderer.parentNode(this.elRef.nativeElement);
                this.renderer.addClass(parent, 'hideSecondChild');
            }
        }
        this.viewContainer.createEmbeddedView(this.templateRef);
    }

    private handleOverrideSwitched(override: boolean): void {
        const parent = this.renderer.parentNode(this.elRef.nativeElement);
        if (override) {
            this.renderer.removeClass(parent, 'hideSecondChild');
        } else {
            this.renderer.addClass(parent, 'hideSecondChild');
        }
    }

    // when we need it, refactor to an interface implemented by each questionnaire separately
    private shouldShowHeaderSwitch(): boolean {
        const zustandigkeit =
            this.taskDataService.getNutzdaten(ZustandigkeitsvereinbarungAngabenComponent.nutzdatenPath) as
                ZustandigkeitsvereinbarungAngaben;
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        return appEnum === AppNameEnum.FragebogenKapGAus && (zustandigkeit.merkerZustaendigV && zustandigkeit.bereitsSteuerlichErfasst);
    }

    private shouldShowContent(): boolean {
        if (this.activatedRoute.snapshot?.data?.data?.optionalWizardStepOverride) {
            return this.activatedRoute.snapshot?.data?.data?.optionalWizardStepOverride;
        }
        const nutzdatenPath = ComponentHelper.getNutzdatenPath(this.activatedRoute.snapshot);
        const data = this.taskDataService.getNutzdaten(nutzdatenPath);
        return data.optionalWizardStepOverride;
    }
}

@Component({
    selector: 'common-ui-info-optional-step',
    template: `
        <common-ui-card type="info" [message]="infoMessage | translate"></common-ui-card>
        <div class="mb-5x common-ui-switch-parent">
            <common-ui-switch [(checked)]="override"></common-ui-switch>
            <label>{{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.OPTIONAL_STEP.OVERRIDE' | translate }}</label>
        </div>`
})
export class InfoOptionalStepComponent implements OnInit {
    @Output()
    public overrideSwitched = new EventEmitter<boolean>();
    public infoMessage = '';
    private overrideInternal = false;

    constructor(private readonly taskDataService: TaskDataService, private readonly activatedRoute: ActivatedRoute) {
        this.infoMessage = InfoOptionalStepComponent.getOptionalInfoMessage();
    }

    get override(): boolean {
        return this.overrideInternal;
    }

    set override(value: boolean) {
        if (this.activatedRoute.snapshot?.data?.data) {
            this.activatedRoute.snapshot.data.data.optionalWizardStepOverride = value;
        }
        this.overrideSwitched.emit(value);
        this.overrideInternal = value;
    }

    private static getOptionalInfoMessage(): string {
        return 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.OPTIONAL_STEP.INFO_MESSAGE';
    }

    ngOnInit(): void {
        const nutzdatenPath = ComponentHelper.getNutzdatenPath(this.activatedRoute.snapshot);
        const data = this.taskDataService.getNutzdaten(nutzdatenPath);
        if (data.optionalWizardStepOverride || this.activatedRoute.snapshot?.data?.data?.optionalWizardStepOverride) {
            this.overrideInternal = true;
        }
    }
}
